import styled from 'styled-components';
import { baseColor } from '../App/theme';
import Button from '@material-ui/core/Button';

export const Container = styled.div`
  display: flex;
  justify-content: center;

  @media (max-width: 800px) {
    flex-direction: column;
    justify-content: center;
  }
`;

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  margin: 40px 2vh 0 2vh;
  max-width: 382px;
`;

export const Title = styled.div`
  font-weight: bold;
  font-size: 38px;
  line-height: 46px;
  letter-spacing: -0.011em;
  color: ${baseColor};
  margin-top: 24px;
`;

export const Text = styled.div`
  font-weight: bold;
  font-size: 20px;
  line-height: 24px;
  letter-spacing: -0.011em;
  color: #333333;
  margin-top: 2vh;
  max-width: 423px;
`;


export const StyledButton = styled(Button)`
  text-transform: none !important;
  font-size: 16px !important;
  margin: 40px 0px 40px 0px !important;
  color: #D81159 !important;
  border: 1px solid #D81159 !important;
  box-sizing: border-box !important;
  border-radius: 30px !important;
`;